import api from './api';
import type { MenuFormat, MenuFormatKind } from '../types/menu';

const base = (venueId: string, menuId: string) =>
  `/admin/venue/${venueId}/menu/${menuId}/formats`;

const menuFormatService = {
  /** List active formats on a menu, ordered by position then name. */
  getFormats: async (venueId: string, menuId: string): Promise<MenuFormat[]> => {
    const response = await api.get(base(venueId, menuId));
    return response.data;
  },

  /** Get a single format. */
  getFormat: async (venueId: string, menuId: string, formatId: string): Promise<MenuFormat> => {
    const response = await api.get(`${base(venueId, menuId)}/${formatId}`);
    return response.data;
  },

  /** Create a format. volumeMl is required iff formatKind === 'VOLUME'. */
  createFormat: async (
    venueId: string,
    menuId: string,
    data: { name: string; formatKind: MenuFormatKind; volumeMl?: number; position?: number },
  ): Promise<MenuFormat> => {
    const response = await api.post(base(venueId, menuId), data);
    return response.data;
  },

  /** Partial update of a format. */
  updateFormat: async (
    venueId: string,
    menuId: string,
    formatId: string,
    data: Partial<{
      name: string;
      formatKind: MenuFormatKind;
      volumeMl: number | null;
      position: number;
      active: boolean;
    }>,
  ): Promise<MenuFormat> => {
    const response = await api.patch(`${base(venueId, menuId)}/${formatId}`, data);
    return response.data;
  },

  /** Soft-delete a format (active=false). */
  deleteFormat: async (venueId: string, menuId: string, formatId: string): Promise<void> => {
    await api.delete(`${base(venueId, menuId)}/${formatId}`);
  },
};

export default menuFormatService;
